import { Box, Divider } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"

const LandingDivider = ({ element }) => (
  <Box contain id={element.anchor_name}>
    <Divider my={`${element.margin || 0}px`} />
  </Box>
)

LandingDivider.propTypes = {
  element: PropTypes.object,
}

export default LandingDivider
